import httpClient from "./httpClient";

const prefix = "/unsubscribe-request";

export async function saveUnsubscribeRequest(body: {
  partner: number;
  reasonUnsubscribe: string;
  temporalUnsubscribe?: boolean;
  banDate?: string;
}) {
  return (await httpClient.post(`${prefix}/save`, body)).data;
}

export async function checkPending(id: number) {
  return (await httpClient.get(`${prefix}/check-pending/${id}`)).data;
}

export async function authorizeOperation(id: number) {
  return (await httpClient.patch(`${prefix}/authorize/${id}`)).data;
}

export async function rejectOperation(
  id: number,
  body: { reasonForRejection: string }
) {
  return (await httpClient.patch(`${prefix}/reject/${id}`, body)).data;
}

export async function checkAllPending(query?: string) {
  return (await httpClient.get(`${prefix}/check-all-pending?${query}`)).data;
}

